export default {"src":"/_next/static/media/0x4d224452801aced8b2f0aebe155379bb5d594381.a3f6e376.svg","height":186,"width":186,"blurWidth":0,"blurHeight":0};